module.exports = __webpack_public_path__ + "static/img/UFS-BCPUJxHT.8849cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/UFS-BCPUJxHT.png
// module id = hzJr
// module chunks = 16